import './App.css';
import { useEffect } from 'react';
import About from './contents/About';
import Contact from './contents/Contact';
import Footer from './contents/Footer';
import Header from './contents/Header';
import Hero from './contents/Hero';
import Services from './contents/Services';
import Testimonials from './contents/Testimonials';
import Topbar from './contents/Topbar';
import initSiteScripts from './script';

function App() {
  useEffect(() => {
    const cleanup = initSiteScripts();
    return () => {
      if (typeof cleanup === 'function') cleanup();
    };
  }, []);

  return (
    <div className="App">
      
      <Topbar />
      <Header />

      <main id="main">
        <Hero />
        <Services />
        <About />
        <Testimonials />
        <Contact />
      </main>

      <Footer />

      <button className="to-top" id="toTop" aria-label="Voltar ao topo">↑</button>

    </div>
  );
}


export default App;
